var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#ff6633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7579 23.8011C13.3352 24.0892 13.8905 24.3953 14.4624 24.6474C15.8699 25.2596 17.3159 25.7397 18.8499 25.7637C19.2568 25.7697 19.6801 25.7097 20.065 25.5717C21.0712 25.2056 21.2746 23.9932 20.4884 23.2069C19.9825 22.7088 19.3612 22.4387 18.7454 22.1566C17.6018 21.6284 16.4362 21.1483 15.3311 20.5361C14.0555 19.8279 13.0163 18.7835 12.5985 17.2471C11.8782 14.6122 12.1531 12.1455 14.0005 10.1048C15.0727 8.92246 16.4417 8.35228 17.9262 8.14221C20.6588 7.74609 23.2869 8.18422 25.8161 9.3726C26.014 9.46863 26.0635 9.57066 26.025 9.79273C25.7721 11.4252 25.5357 13.0638 25.2828 14.7503C25.1618 14.6963 25.0574 14.6482 24.9584 14.6002C23.6443 13.94 22.2918 13.4179 20.8457 13.2738C20.3069 13.2198 19.7461 13.2378 19.2073 13.3098C18.7619 13.3698 18.4046 13.6579 18.2946 14.1861C18.1846 14.7023 18.3826 15.1104 18.7289 15.4345C19.3063 15.9687 20.0045 16.2447 20.6918 16.5508C21.621 16.971 22.5612 17.3611 23.4739 17.8232C24.3041 18.2374 25.0464 18.8135 25.6622 19.5578C26.7673 20.9022 27.0697 22.5287 26.9872 24.2693C26.9267 25.6137 26.6188 26.8741 25.8931 27.9844C24.9529 29.4249 23.6278 30.2231 22.0938 30.6372C20.3784 31.0994 18.6465 31.0814 16.9091 30.7993C15.3091 30.5412 13.7641 30.0611 12.3016 29.2928C12.0267 29.1488 11.9662 28.9927 12.0157 28.6806C12.2631 27.1262 12.4885 25.5657 12.7194 24.0112C12.7304 23.9332 12.7469 23.8671 12.7579 23.8011Z",
    fill: "#F4F4F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeIcon);
export default __webpack_public_path__ + "static/media/stripe-icon.48807e5bda2ac9f2a571470661ba6d9e.svg";
export { ForwardRef as ReactComponent };